import { Module } from "vuex";
import { RootState } from "@/store/interfaces/root";
import { UserState } from "@/store/interfaces/user";

import { state } from "./state";
import { getters } from "./getters";
import { mutations } from "./mutations";
import { actions } from "./actions";

export const user: Module<UserState, RootState> = {
  state,
  getters,
  mutations,
  actions
};
